import React, { FC, ReactNode } from "react";
import styles from "./index.module.scss";
import cn from "classnames";

// React.ButtonHTMLAttributes<HTMLButtonElement>
interface ExamOptionProps extends React.AllHTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  type?: "success" | "error" | "";
}

const ExamOption: FC<ExamOptionProps> = ({
  children,
  className,
  type = "",
  onClick,
  disabled,
}) => {
  return (
    <div
      className={cn(
        styles.option,
        className,
        type === "success" && styles.optionSuccess,
        type === "error" && styles.optionError,
        disabled && styles.disabled
      )}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export default ExamOption;
